import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import '../login/v3/login.scss';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password,  setPassword]  = useState('');
  const [password2, setPassword2] = useState('');
  const [showPw,    setShowPw]    = useState(false);
  const [msg,       setMsg]       = useState('');
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);

  if (!token) {
    return (
      <div className="v3-wrapper">
        <div className="v3-card" style={{ maxWidth: 440, minHeight: 'unset' }}>
          <div className="v3-right" style={{ flex: 1, padding: '48px 44px 36px' }}>
            <div className="v3-error">Invalid or missing reset token.</div>
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}>
              <span style={{ color: '#8bc34a', cursor: 'pointer', fontWeight: 600 }} onClick={() => navigate('/login')}>
                ← Back to Sign In
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== password2) { setError('Passwords do not match.'); return; }
    if (password.length < 6)    { setError('Password must be at least 6 characters.'); return; }

    setLoading(true);
    try {
      const { data } = await api.post('/auth/reset-password', { token, password });
      setMsg(data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="v3-wrapper">
      <div className="v3-card" style={{ maxWidth: 440, minHeight: 'unset' }}>
        <div className="v3-right" style={{ flex: 1, padding: '48px 44px 36px' }}>
          <div className="v3-form-inner">
            <h2 className="v3-title">Reset Password</h2>
            <p className="v3-subtitle">Enter your new password below.</p>

            {error && <div className="v3-error">{error}</div>}

            {msg ? (
              <>
                <div style={{ background: '#f0faf0', border: '1px solid #8bc34a', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 18, color: '#3a6b1e' }}>
                  {msg}
                </div>
                <button className="v3-btn-signin" onClick={() => navigate('/login')}>
                  Sign In
                </button>
              </>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <div className="v3-field">
                  <label>New Password</label>
                  <div className="v3-input-wrap">
                    <span className="v3-input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                    </span>
                    <input
                      type={showPw ? 'text' : 'password'}
                      placeholder="New password (min 6 chars)"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      required
                      autoComplete="new-password"
                    />
                    <button type="button" className="v3-toggle-pw" onClick={() => setShowPw(v => !v)} tabIndex={-1}>
                      {showPw ? (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                          <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                          <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                      ) : (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                          <circle cx="12" cy="12" r="3"/>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <div className="v3-field">
                  <label>Confirm Password</label>
                  <div className="v3-input-wrap">
                    <span className="v3-input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                    </span>
                    <input
                      type={showPw ? 'text' : 'password'}
                      placeholder="Repeat new password"
                      value={password2}
                      onChange={e => setPassword2(e.target.value)}
                      required
                      autoComplete="new-password"
                    />
                  </div>
                </div>

                <button className="v3-btn-signin" type="submit" disabled={loading}>
                  {loading ? 'Saving…' : 'Set New Password'}
                </button>
              </form>
            )}

            <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13 }}>
              <span style={{ color: '#8bc34a', cursor: 'pointer', fontWeight: 600 }} onClick={() => navigate('/login')}>
                ← Back to Sign In
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
